import { render, staticRenderFns } from "./AppContactsChannels.vue?vue&type=template&id=a4f21238"
import script from "./AppContactsChannels.vue?vue&type=script&lang=js"
export * from "./AppContactsChannels.vue?vue&type=script&lang=js"
import style0 from "./AppContactsChannels.vue?vue&type=style&index=0&id=a4f21238&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports